import React from 'react';
import SectionType from './SectionType';

export interface SectionProps {
  type?: SectionType,
}

export default class Section extends React.Component<SectionProps> {
  static Type = SectionType;

  render() {
    const {
      children,
      type = SectionType.DEFAULT,
    } = this.props;

    /* eslint-disable no-nested-ternary, operator-linebreak, @typescript-eslint/indent */
    const additionalStyleClass = (type === SectionType.INVERT) ?
      'section-invert' :
      (type === SectionType.DECENT) ?
      'section-decent' :
      (type === SectionType.PROMINENT) ?
      'section-prominent' :
      '';
      return (
        <section className={`section ${additionalStyleClass}`} data-js="section-wrapper">
          <div className="inner">
            {children}
          </div>
        </section>
      );
  }
}
